import api from './api';

const settingsService = {
  getSettings: async () => {
    const response = await api.get('/admin/settings');
    return response.data.data.settings;
  },

  // Bulk save of { key: value } pairs. The API validates each value against
  // the setting's own type and rejects the whole batch if one is wrong.
  updateSettings: async (values) => {
    const response = await api.put('/admin/settings', { values });
    return response.data.data.settings;
  },
};

export default settingsService;
